/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { GlobalConstants } from '../../constants/global-constants';
import { MenuItem } from './types';
import { createDialog } from '../../popup-dialog-factory/popup-dialog.facade';
import { AcrylicSurfaceService } from '../../acrylic-surface/acrylic-surface.service';
import { LocalStorageService } from '../../../../../../toolbelt/utils/src/lib/local-storage/local-storage.service';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { SystemOperationsService } from './system-operations.service';

@Component({
  selector: 'sysque-system-operations',
  templateUrl: './system-operations.component.html',
  styleUrl: './system-operations.component.scss',
  standalone: false
})
export class SystemOperationsComponent {
  public selectedSystem: string = '';
  public get isRenameDeleteDisabled(): boolean {
    return this.selectedSystem === '';
  }

  public get menuItems(): MenuItem[] {
    return [
      { label: GlobalConstants.CreateSystem, disabled: false },
      { label: GlobalConstants.RenameSystem, disabled: this.isRenameDeleteDisabled },
      { label: GlobalConstants.DeleteSystem, disabled: this.isRenameDeleteDisabled },
    ];
  }

  public ngOnInit() {
    window.addEventListener(GlobalConstants.STORAGE, this.storageEventListener.bind(this));
  }

  constructor(
    private acrylicSurfaceService: AcrylicSurfaceService,
    private localStorageService: LocalStorageService,
    private systemOperationsService: SystemOperationsService,
    private cdr: ChangeDetectorRef
  ) {}

  public handleContextMenuItem(item: string): void {
    this.localStorageService.updateDispatchLocalStorage(
      GlobalConstants.SCOPE,
      GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY
    );
    this.acrylicSurfaceService.show();
    let sysquePopupConfig = new SysquePopupConfig();
    switch (item) {
      case GlobalConstants.CreateSystem:
        createDialog(sysquePopupConfig, GlobalConstants.CREATE_SYSTEM_NAME_DIALOG);
        this.systemOperationsService.openDialog(
          GlobalConstants.CREATE_SYSTEM_NAME_DIALOG,
          sysquePopupConfig.width,
          sysquePopupConfig.height
        );
        break;

      case GlobalConstants.RenameSystem:
        createDialog(sysquePopupConfig, GlobalConstants.RENAME_SYSTEM_NAME_DIALOG);
        this.systemOperationsService.openDialog(
          GlobalConstants.RENAME_SYSTEM_NAME_DIALOG,
          sysquePopupConfig.width,
          sysquePopupConfig.height
        );
        break;

      case GlobalConstants.DeleteSystem:
        createDialog(sysquePopupConfig, GlobalConstants.DELETE_SYSTEM_NAME_DIALOG);
        this.systemOperationsService.openDialog(
          GlobalConstants.DELETE_SYSTEM_NAME_DIALOG,
          sysquePopupConfig.width,
          sysquePopupConfig.height
        );
        break;
      default:
        break;
    }
  }

  public storageEventListener(event: StorageEvent): void {
    if (event.key === GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY) {
      const dockedState = event.newValue && JSON.parse(event.newValue);
      this.selectedSystem = dockedState.selectedSystem;
      this.cdr.markForCheck();
    }
  }
}
